import { encode, decode } from 'multiformats/block';
import { sha256 as hasher } from 'multiformats/hashes/sha2';
import * as raw from 'multiformats/codecs/raw';
import * as CBW from '@ipld/car/buffer-writer';
import * as codec from '@ipld/dag-cbor';
export async function innerMakeCarFile(fp, t) {
    const { cid, bytes } = await encodeCarHeader(fp);
    await t.put(cid, bytes);
    return encodeCarFile(cid, t);
}
export async function encodeCarFile(carHeaderBlockCid, t) {
    let size = 0;
    // console.log('encodeCarFile', carHeaderBlockCid.bytes.byteLength, { carHeaderBlockCid }, CBW.headerLength)
    const headerSize = CBW.headerLength({ roots: [carHeaderBlockCid] });
    size += headerSize;
    for (const { cid, bytes } of t.entries()) {
        size += CBW.blockLength({ cid, bytes });
    }
    const buffer = new Uint8Array(size);
    const writer = CBW.createWriter(buffer, { headerSize });
    writer.addRoot(carHeaderBlockCid);
    for (const { cid, bytes } of t.entries()) {
        writer.write({ cid, bytes });
    }
    writer.close();
    return await encode({ value: writer.bytes, hasher, codec: raw });
}
export async function encodeCarHeader(fp) {
    return (await encode({
        value: { fp },
        hasher,
        codec
    }));
}
export async function parseCarFile(reader) {
    const roots = await reader.getRoots();
    const header = await reader.get(roots[0]);
    if (!header)
        throw new Error('missing header block');
    const { value } = await decode({ bytes: header.bytes, hasher, codec });
    // @ts-ignore
    if (value && value.fp === undefined)
        throw new Error('missing fp');
    const { fp } = value;
    return fp;
}
